module.exports = __webpack_public_path__ + "img/ic-now-play.607d9a59.png";